import { ColorEnum } from '@/constants/color'
import CreateShiftCloseoutPrompt from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt'
import { useShiftCloseouts } from '@/features/shiftCloseouts/hooks/useShiftCloseouts'
import { useAppSelector } from '@/hooks/redux'
import { useScreenLayout } from '@/hooks/screen'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { useRouter } from 'expo-router'
import { FC } from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'

const ShiftCloseoutsPage: FC = () => {
    const layout = useScreenLayout()
    const router = useRouter()
    const history = useShiftCloseouts()
    const isOrdersLoaded = useAppSelector(ordersSelectors.isOrdersLoaded)
    const hasOpenOrders = useAppSelector(ordersSelectors.hasOpenOrders)

    if (!isOrdersLoaded) {
        return (
            <View style={styles.container}>
                <ActivityIndicator />
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <CreateShiftCloseoutPrompt
                history={history}
                layout={layout}
                hasOpenOrders={hasOpenOrders}
                onCashTransactions={() => router.push('/shift-closeouts/cash-transactions')}
                onCreate={() => router.push('/shift-closeouts/new')}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: ColorEnum.WHITE,
    },
})

export default ShiftCloseoutsPage
